import Mahakumbh from "../pages/Mahakumbh";
import env from "./env";

const Get = {
  Location: (lat, long) => {
    return new Promise((resolve, reject) => {
      fetch(
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
          lat +
          "," +
          long +
          "&key=AIzaSyDTZlQB2hhTNQe_IjSE2T9a8VkKVkxExxc",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  placeGet: (id) => {
    return new Promise((resolve, reject) => {
      fetch(
        "https://maps.googleapis.com/maps/api/place/details/json?place_id=" +
          id +
          "&key=AIzaSyDTZlQB2hhTNQe_IjSE2T9a8VkKVkxExxc",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  circleGet: (latitude, longitude) => {
    return new Promise((resolve, reject) => {
      fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyDTZlQB2hhTNQe_IjSE2T9a8VkKVkxExxc`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  GetCityPincode: (pincode) => {
    return new Promise((resolve, reject) => {
      fetch(
        "https://maps.googleapis.com/maps/api/geocode/json?address=" +
          pincode +
          "&key=AIzaSyDTZlQB2hhTNQe_IjSE2T9a8VkKVkxExxc",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  MessageTemplates: () => {
    return new Promise((resolve, reject) => {
      fetch(env.url + "/vehicle-message", {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  MyVehicle: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/vehicle", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  MemberVehicles: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/vehicle/" + id, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  CashbackDiscount: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/pay_bill/" + id, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getUser: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/user", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getMembers: ({
    page = 1,
    perPage = 5,
    search = "",
    classFilter,
    sectionFilter,
    type = "",
  }) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (!user) {
        reject(new Error("User not found in localStorage"));
        return;
      }

      const parsedUser = JSON.parse(user); // Parse the user data

      // Construct URL with pagination and filters
      const url = new URL(`${env.url}/get-user/members`);
      url.searchParams.append("page", page);
      url.searchParams.append("per_page", perPage);

      if (search) url.searchParams.append("search", search);
      if (classFilter) url.searchParams.append("class", classFilter);
      if (sectionFilter) url.searchParams.append("section", sectionFilter);
      if (type) url.searchParams.append("type", type);

      fetch(url.toString(), {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${parsedUser.token}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json(); // Parse JSON response
        })
        .then((data) => {
          console.log(data); // Log parsed JSON
          resolve(data); // Resolve with parsed data
        })
        .catch((error) => {
          console.error("Fetch error:", error); // Log any fetch errors
          reject(error); // Reject with error
        });
    });
  },

  getStudents: async (className = "", section = "", date = "") => {
    try {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (!user) throw new Error("User not found in localStorage");

      const parsedUser = JSON.parse(user); // Parse user data

      // Construct URL dynamically to avoid empty parameters
      let url = new URL(env.url + `/student`);
      url.searchParams.append("school", parsedUser.id);
      if (className) url.searchParams.append("class", className);
      if (section) url.searchParams.append("section", section);
      if (date) url.searchParams.append("date", date);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${parsedUser.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data); // Log parsed JSON
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      throw error; // Ensure the error propagates
    }
  },

  getAllStudents: async ({ classFilter, sectionFilter }) => {
    try {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (!user) throw new Error("User not found in localStorage");

      const parsedUser = JSON.parse(user); // Parse user data

      // Construct URL dynamically to avoid empty parameters
      let url = new URL(env.url + `/student/create`);
      if (classFilter) url.searchParams.append("class", classFilter);
      if (sectionFilter) url.searchParams.append("section", sectionFilter);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${parsedUser.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data); // Log parsed JSON
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      throw error; // Ensure the error propagates
    }
  },

  getAllMembers: async ({ type }) => {
    try {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (!user) throw new Error("User not found in localStorage");

      const parsedUser = JSON.parse(user); // Parse user data

      // Construct URL dynamically to avoid empty parameters
      let url = new URL(env.url + `/get-all-members`);
      if (type) url.searchParams.append("type", type);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${parsedUser.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data); // Log parsed JSON
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      throw error; // Ensure the error propagates
    }
  },

  getAttendance: async (date, type) => {
    try {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (!user) throw new Error("User not found in localStorage");

      const parsedUser = JSON.parse(user); // Parse user data

      // Construct URL dynamically to avoid empty parameters
      let url = new URL(env.url + `/attendance`);
      url.searchParams.append("company", parsedUser.id);
      if (date) url.searchParams.append("date", date);
      if (type) url.searchParams.append("type", type);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${parsedUser.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data); // Log parsed JSON
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      throw error; // Ensure the error propagates
    }
  },

  getSingleAttendance: async (id, date, type) => {
    try {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (!user) throw new Error("User not found in localStorage");

      const parsedUser = JSON.parse(user); // Parse user data

      // Construct URL dynamically to avoid empty parameters
      let url = new URL(env.url + `/attendance/${id}`);
      if (date) url.searchParams.append("date", date);
      if (type) url.searchParams.append("type", type);

      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${parsedUser.token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log(data); // Log parsed JSON
      return data;
    } catch (error) {
      console.error("Fetch error:", error);
      throw error; // Ensure the error propagates
    }
  },

  getSingleStudent: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/student/${id}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse JSON response
          })
          .then((data) => {
            console.log(data); // Log parsed JSON
            resolve(data); // Resolve with parsed data
          })
          .catch((error) => {
            console.error("Fetch error:", error); // Log any fetch errors
            reject(error); // Reject with error
          });
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getStudentList: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/student/${id}/edit`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse JSON response
          })
          .then((data) => {
            console.log(data); // Log parsed JSON
            resolve(data); // Resolve with parsed data
          })
          .catch((error) => {
            console.error("Fetch error:", error); // Log any fetch errors
            reject(error); // Reject with error
          });
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getSingleMember: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/get-user/member/${id}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json(); // Parse JSON response
          })
          .then((data) => {
            console.log(data); // Log parsed JSON
            resolve(data); // Resolve with parsed data
          })
          .catch((error) => {
            console.error("Fetch error:", error); // Log any fetch errors
            reject(error); // Reject with error
          });
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getCartItems: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/cart", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  removeCartItems: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/cart/" + id, {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  Slider: (page, locate) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        console.log("token", parsedUser.token);

        fetch(env.url + "/banner?page=" + page + "&locate=" + locate, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => {
            console.log("res", res);
            resolve(res);
          });
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  ListingCategory: (limit, search = "") => {
    return new Promise((resolve, reject) => {
      // const user = localStorage.getItem('user'); // Get user synchronously
      // if (user) {
      // const parsedUser = JSON.parse(user); // Parse the user data
      fetch(
        env.url + "/listing-category?limit=" + limit + "&search=" + search,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            // Authorization: 'Bearer ' + parsedUser.token
          },
        }
      )
        .then((res) => res.json())
        .then((res) => resolve(res));
      // } else {
      //     reject(new Error("User not found in localStorage"));
      // }
    });
  },

  Listing: (slug, page) => {
    return new Promise((resolve, reject) => {
      // const user = localStorage.getItem('user'); // Get user synchronously
      // if (user) {
      // const parsedUser = JSON.parse(user); // Parse the user data
      fetch(env.url + "/listing?slug=" + slug + "&page=" + page, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: 'Bearer ' + parsedUser.token
        },
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
      // } else {
      //     reject(new Error("User not found in localStorage"));
      // }
    });
  },

  SearchListing: (search, page) => {
    return new Promise((resolve, reject) => {
      // const user = localStorage.getItem('user'); // Get user synchronously
      // if (user) {
      // const parsedUser = JSON.parse(user); // Parse the user data
      fetch(env.url + "/listing?search=" + search + "&page=" + page, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: 'Bearer ' + parsedUser.token
        },
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
      // } else {
      //     reject(new Error("User not found in localStorage"));
      // }
    });
  },

  ListingByUser: (category, page) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/listing-by-user", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  ListingBySlug: (slug) => {
    return new Promise((resolve, reject) => {
      // const user = localStorage.getItem('user'); // Get user synchronously
      // if (user) {
      //     const parsedUser = JSON.parse(user); // Parse the user data
      fetch(env.url + `/listing/${slug}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: 'Bearer ' + parsedUser.token
        },
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
      // } else {
      //     reject(new Error("User not found in localStorage"));
      // }
    });
  },

  MyVehicle: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/vehicle", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((error) => reject(error)); // Handle errors
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  Parkings: (type, lat = "", long = "", limit) => {
    return new Promise((resolve, reject) => {
      console.log(
        env.url +
          "/parking?type=" +
          type +
          "&lat=" +
          lat +
          "&long=" +
          long +
          "&limit=" +
          limit
      );
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(
          env.url +
            "/parking?type=" +
            type +
            "&lat=" +
            lat +
            "&long=" +
            long +
            "&limit=" +
            limit,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + parsedUser.token,
            },
          }
        )
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  Setting: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/setting", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  Puc: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/puc", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + JSON.parse(user).token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  Challan: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/challan", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  Coupan: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/coupan", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  Notification: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user);
        fetch(env.url + "/notification", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + user.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  Address: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/address", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
  Page: (type) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/page?type=" + type, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  Wallet: (from = "", to = "", page = 1, type = "") => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        const url = new URL(env.url + "/wallet/create");
        if (from) url.searchParams.append("from", from);
        if (to) url.searchParams.append("to", to);
        url.searchParams.append("page", page);
        if (type) url.searchParams.append("type", type);

        fetch(url, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getTransactions: (type = "", from = "", to = "") => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/wallet/create?type=${type}&from=${from}&to=${to}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  ScanQr: (data) => {
    return new Promise((resolve, reject) => {
      fetch(env.url + "/scan-qr?url=" + data, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
    });
  },

  getProducts: (query = "") => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/products${query}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getInsuranceUrl: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/insurance-lead/${parsedUser.id}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getOrders: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/place_order", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getOrderDetails: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/place_order/" + id, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getCategories: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/shop-category", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getBrands: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/shop-brand", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getTickets: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/support", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getTicketChat: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/support/${id}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getTransaction: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/wallet/" + id, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getParkingBookings: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/bookParking/" + id, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getCreditCardLeads: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + "/credit_card", {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  getPageContent: (slug) => {
    return new Promise((resolve, reject) => {
      // const user = localStorage.getItem('user'); // Get user synchronously
      // if (user) {
      //     const parsedUser = JSON.parse(user); // Parse the user data
      fetch(env.url + `/page?type=${slug}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          // Authorization: 'Bearer ' + parsedUser.token
        },
      })
        .then((res) => res.json())
        .then((res) => resolve(res));
      // } else {
      //     reject(new Error("User not found in localStorage"));
      // }
    });
  },

  Mahakumbh: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user"); // Get user synchronously
      if (user) {
        const parsedUser = JSON.parse(user); // Parse the user data
        fetch(env.url + `/mahakumbh?user_id=${id ? id : ""}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  InsuranceHistory: (page = 1) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        fetch(`${env.url}/success-lead?page=${page}`, {
          // Pass page number
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  DownloadInsurancePDF: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        fetch(`${env.url}/success-lead/${id}`, {
          // Pass page number
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  MLMNetwork: (id = "", page = 1, reg_no = "", filter = "") => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        fetch(
          `${env.url}/mlm_network?user=${id}&page=${page}&reg_no=${reg_no}&filter=${filter}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + parsedUser.token,
            },
          }
        )
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  MLMEditData: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        fetch(`${env.url}/mlm_network/create`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  MLMNetworkTree: (
    id = "",
    selectedType = "",
    selectedRank = "",
    search = ""
  ) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        fetch(
          `${env.url}/mlm_network_tree?user=${id}&plan_type=${selectedType}&rank=${selectedRank}&search=${search}`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: "Bearer " + parsedUser.token,
            },
          }
        )
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  MLMIncome: (page = 1, level = "All", type, rank = "") => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        const url = new URL(`${env.url}/mlm-income`);
        url.searchParams.append("page", page);
        url.searchParams.append("type", type);
        if (level) {
          url.searchParams.append("level", level);
        }
        if (rank) {
          url.searchParams.append("rank", rank);
        }
        fetch(url.toString(), {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  MLMLevelIncome: () => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        const url = new URL(`${env.url}/mlm-income/create`);
        fetch(url.toString(), {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  MLMLevelCalculate: (level, type) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        const url = new URL(`${env.url}/mlm-level-income/calculate`);
        url.searchParams.append("level", level);
        url.searchParams.append("type", type);
        fetch(url.toString(), {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  MLMUserDetails: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        const url = new URL(`${env.url}/mlm_network/${id}`);
        fetch(url.toString(), {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  MLMWithdrawalHistory: ({ page = 1, from, to } = {}) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        const url = new URL(`${env.url}/mlm-history`);
        url.searchParams.append("page", page);
        if (from) url.searchParams.append("from", from);
        if (to) url.searchParams.append("to", to);

        fetch(url.toString(), {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },

  VehicleMessages: (id) => {
    return new Promise((resolve, reject) => {
      const user = localStorage.getItem("user");
      if (user) {
        const parsedUser = JSON.parse(user);
        fetch(`${env.url}/vehicle-message/${id}`, {
          // Pass page number
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + parsedUser.token,
          },
        })
          .then((res) => res.json())
          .then((res) => resolve(res))
          .catch((err) => reject(err));
      } else {
        reject(new Error("User not found in localStorage"));
      }
    });
  },
};

export default Get;
